import React from 'react';
import { Card, Space, Tooltip, Typography } from 'antd';
import { InfoCircleOutlined, PlusOutlined } from '@ant-design/icons';
import styles from './OfferedItems.module.scss';
import { OfferedItemLookup } from './useOfferedItemsDataSource';
import { AddPersonalizationItemButton } from '../Item.Details';
import { formatters } from '@/core';
import { TBDPrice } from '@/views/Personalization.Summary';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

const { Text } = Typography;

export type ProjectHomeIdentifiersProps = {
  communityId: string;
  projectId: string;
  homeId: string;
};

type Props = ProjectHomeIdentifiersProps & {
  stepId: string;
  item: OfferedItemLookup;
  className?: string;
};

export const OfferedItemDetails: React.FC<Props> = (props) => {
  const { item, communityId, projectId, homeId, stepId, className } = props;
  const { t } = useTranslation(undefined, {
    keyPrefix: 'personalization.floorplan.offeredItems',
  });

  return (
    <Card
      key={item.id}
      id={`item-${item.id}`}
      className={classNames(styles.itemCard, className)}
    >
      <Tooltip title={item.name}>
        <Text strong ellipsis>
          {item.name}
        </Text>
      </Tooltip>
      <div className={styles.itemRow}>
        <Price {...props} />

        <Space>
          <AddPersonalizationItemButton
            communityId={communityId}
            homeId={homeId}
            projectId={projectId}
            onSubmit={false}
            itemId={item.id}
            stepId={stepId}
            iconOnly
            type="link"
            buttonClassName={styles.addButton}
            icon={<InfoCircleOutlined />}
            texts={{
              modalSaveBtn: t('add'),
              modalCloseBtn: t('cancel'),
              modalTitle: t('details'),
            }}
            isFloorplan={true}
          />
          <AddPersonalizationItemButton
            communityId={communityId}
            homeId={homeId}
            projectId={projectId}
            onSubmit={false}
            itemId={item.id}
            stepId={stepId}
            iconOnly
            type="link"
            buttonClassName={styles.addButton}
            icon={<PlusOutlined />}
            texts={{ modalSaveBtn: t('add'), modalCloseBtn: t('cancel') }}
            isFloorplan={true}
          />
        </Space>
      </div>
    </Card>
  );
};

function Price(props: Props) {
  const { item } = props;
  return (
    <>
      {item.tbd || item.price == null ? (
        <TBDPrice />
      ) : (
        <Text>${formatters.price(item.price)}</Text>
      )}
    </>
  );
}
